import moment from 'moment'

export default {
  name: 'token-countdown',
  props: {
    token: {
      type: Boolean,
      required: true
    },
    tokenExpiration: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      timeRemaining: '',
      showRevalidateButton: false,
      interval: null
    }
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    this.clearCountdownInterval()
  },
  watch: {
    token() {
      this.startCountdown()
    },
    tokenExpiration() {
      this.startCountdown()
    }
  },
  methods: {
    startCountdown () {
      this.clearCountdownInterval()

      if (this.token && this.tokenExpiration) {
        this.calculateTimeRemaining()
        this.interval = setInterval(this.calculateTimeRemaining, 1000)
      } else {
        this.timeRemaining = ''
        this.showRevalidateButton = false
      }
    },
    clearCountdownInterval () {
      clearInterval(this.interval)
      this.interval = null
    },
    calculateTimeRemaining() {
      const expiration = moment(this.tokenExpiration)
      const now = moment()
      const duration = moment.duration(expiration.diff(now))
    
      if (duration.asSeconds() <= 0) {
        this.clearCountdownInterval()
        this.timeRemaining = this.$t('token.expired_token')
        this.showRevalidateButton = false
        this.$emit('tokenExpired')
      } else {
        const days = duration.days()
        const hours = duration.hours()
        const minutes = duration.minutes()
        const seconds = duration.seconds()
        const remainingHours = duration.asHours()
      
        this.timeRemaining = `${days}d ${hours}h ${minutes}m ${seconds}s`
        this.showRevalidateButton = remainingHours <= 24
      }
    },
    revalidateToken() {
      this.$emit('revalidateToken')
    }
  }
}
